import { Skeleton } from '@ideoz/ui';

/** Dumb: placeholder shown while the primary project loads. */
export function DesignSystemSkeleton(): JSX.Element {
  return (
    <div className="flex h-full overflow-hidden">
      <div className="hidden w-[220px] shrink-0 border-r border-gray-100 px-5 py-6 xl:block">
        <Skeleton className="mb-3 h-3 w-20" />
        <div className="space-y-2">
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
        </div>
      </div>
      <div className="flex flex-1 justify-center bg-gray-50/60 px-6 py-6">
        <div className="w-full max-w-[540px] space-y-4">
          <Skeleton className="mb-2 h-7 w-40" />
          <Skeleton className="h-4 w-full max-w-sm" />
          <Skeleton className="h-48 w-full rounded-2xl" />
          <Skeleton className="h-56 w-full rounded-2xl" />
          <Skeleton className="h-40 w-full rounded-2xl" />
        </div>
      </div>
      <div className="hidden w-[340px] shrink-0 border-l border-gray-100 xl:block">
        <Skeleton className="h-full w-full" />
      </div>
    </div>
  );
}
